enum PlaceInFlowPages {
  PHONE_NUMBER = 'PHONE_NUMBER',
  PHONE_VERIFICATION = 'PHONE_VERIFICATION',
  CUSTOMER_DETAILS = 'CUSTOMER_DETAILS',
  EMAIL_VERIFICATION = 'EMAIL_VERIFICATION',
  PAYMENT_PLAN = 'PAYMENT_PLAN',
  PAYMENT_METHOD = 'PAYMENT_METHOD',
  AGREEMENT = 'AGREEMENT',
  AUTHORIZATION = 'AUTHORIZATION',
  THANK_YOU = 'THANK_YOU',
}

export default PlaceInFlowPages;
